export enum TaskType {
  DownTime = 'Downtime',
  QaCheck = 'QaCheck',
  All = 'All'
}
